<div class="page-wrapper p-1">	
	<div class="container">
		<div class="row all-report">
			<div class="col-md-12 ">
			  	<nav>
					<div class="nav nav-tabs nav-fill " id="nav-tab" role="tablist">
						<a class="nav-item nav-link active border-right" id="nav-home-tab"  data-toggle="tab" href="#nav-home" >Home</a>
						<a class="nav-item nav-link border-right" id="nav-detailed-tab" data-toggle="tab" href="#nav-detailed">Detailed</a>
						<a class="nav-item nav-link border-right" id="nav-segmentation-tab" data-toggle="tab" href="#nav-segmentation">Segmentation</a>
						<a class="nav-item nav-link border-right" id="nav-program-tab" data-toggle="tab" href="#nav-program">Affiliation</a>
					</div>
			  	</nav>
			  	<div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
					<div class="tab-pane fade show active row" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
						<div class="col-md-12">
							<div class="col-filter row">
								<div class="col-md-4">
									<app-select idKey="key" labelKey="value" [options]="colleges" 
										 [model]="collegeName" placeHolder="All High Schools" sortRequired="true"
							 			 (selectChange)="collegeName=$event;getCollegeReport($event);getDetailsPageChartData($event);"></app-select>
								</div>
								<div class="col-md-8 text-right"><span (click)="showAccordionView()"  style="cursor: pointer;margin-right: 5px;">{{accordionView ? 'Hide Accordion View':'Show Accordion View'}}</span></div>
							</div>
							<div class="col-filter row mt-3">
								<div class="col-md-12" style="font-size: x-large;" *ngIf="!displayreports">Loading...</div>
								<div class="col-md-12" *ngIf="displayreports">
									<div class="row" *ngIf="accordionView">
										<div class="col-md-12">
											<div class="row"> 
												<div class="col-md-8 mt-3">
													<accordion [isAnimated]="true">
														<accordion-group [isOpen]="group.complete" class="mb-3" *ngIf="applicationCounts.complete > 0">
															<button class="btn btn-link btn-block clearfix" accordion-heading type="button">
																<div class="pull-left float-left">COMPLETE APPLICATIONS</div>
																<span class="badge  float-right pull-right">{{applicationCounts.complete}}</span>
															</button>
															<table class="table table-striped">
																<thead>
																	<tr>
																		<th scope="col">AppID</th>
																		<th scope="col">First Name</th>
																		<th scope="col">Last Name</th>
																		<th scope="col">Race/EtHnicity</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let com of reportsData.complete">
																		<td>{{com.applicationCode}}</td>
																		<td>{{com.firstName}}</td>
																		<td>{{com.lastName}}</td>
																		<td>{{com.ethnicity}}</td>
																	</tr>
																</tbody>
															</table>
														</accordion-group>
														<accordion-group [isOpen]="group.incomplete" class="mb-3" *ngIf="applicationCounts.incomplete > 0">
															<button class="btn btn-link btn-block clearfix" accordion-heading type="button">
																<div class="pull-left float-left">INCOMPLETE APPLICATIONS</div>
																<span class="badge  float-right pull-right">{{applicationCounts.incomplete}}</span>
															</button>
															<table class="table table-striped">
																<thead>
																	<tr>
																		<th scope="col">AppID</th>
																		<th scope="col">First Name</th>
																		<th scope="col">Last Name</th>
																		<th scope="col">Completed Steps</th>
																		<th scope="col">% Completion</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let com of reportsData.incomplete">
																		<td>{{com.applicationCode}}</td>
																		<td>{{com.firstName}}</td>
																		<td>{{com.lastName}}</td>
																		<td>{{com.completedSteps}}</td>
																		<td>{{com.percentCompletion}}%</td>
																	</tr>
																</tbody>
															</table>
														</accordion-group>
														<accordion-group [isOpen]="group.submission_pending" class="mb-3"  *ngIf="applicationCounts.submission_pending > 0">
															<button class="btn btn-link btn-block clearfix" accordion-heading type="button">
																<div class="pull-left float-left">ONLY SUBMISSION PENDING</div>
																<span class="badge  float-right pull-right">{{applicationCounts.submission_pending}}</span>
															</button>
															<table class="table table-striped">
																<thead>
																	<tr>
																		<th scope="col">AppID</th>
																		<th scope="col">First Name</th>
																		<th scope="col">Last Name</th>
																		<th scope="col">Completed Steps</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let com of reportsData.submission_pending">
																		<td>{{com.applicationCode}}</td>
																		<td>{{com.firstName}}</td>
																		<td>{{com.lastName}}</td>
																		<td>{{com.completedSteps}}</td>
																	</tr>
																</tbody>
															</table>
														</accordion-group>
														<accordion-group [isOpen]="group.transcripts_pending" class="mb-3" *ngIf="applicationCounts.transcripts_pending > 0">
															<button class="btn btn-link btn-block clearfix" accordion-heading type="button">
																<div class="pull-left float-left">ONLY TRANSCRIPTS REQUIRED</div>
																<span class="badge  float-right pull-right">{{applicationCounts.transcripts_pending}}</span>
															</button>
															<table class="table table-striped">
																<thead>
																	<tr>
																		<th scope="col">AppID</th>
																		<th scope="col">First Name</th>
																		<th scope="col">Last Name</th>
																		<th scope="col">Completed Steps</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let com of reportsData.transcripts_pending">
																		<td>{{com.applicationCode}}</td>
																		<td>{{com.firstName}}</td>
																		<td>{{com.lastName}}</td>
																		<td>{{com.completedSteps}}</td>
																	</tr>
																</tbody>
															</table>
														</accordion-group>
														<accordion-group [isOpen]="group.recommendation_pending"  class="mb-3" *ngIf="applicationCounts.recommendation_pending > 0">
															<button class="btn btn-link btn-block clearfix" accordion-heading type="button">
																<div class="pull-left float-left">ONLY RECOMMENDATIONS PENDING</div>
																<span class="badge float-right pull-right">{{applicationCounts.recommendation_pending}}</span>
															</button>
															<table class="table table-striped">
																<thead>
																	<tr>
																		<th scope="col">AppID</th>
																		<th scope="col">First Name</th>
																		<th scope="col">Last Name</th>
																		<th scope="col">Recommendation 1</th>
																		<th scope="col">Recommendation 2</th>
																		<th scope="col">Color Code</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let com of reportsData.recommendation_pending">
																		<td>{{com.applicationCode}}</td>
																		<td>{{com.firstName}}</td>
																		<td>{{com.lastName}}</td>
																		<td>{{com.readerScore1}}</td>
																		<td>{{com.readerScore2}}</td>
																		<td [ngStyle]="{'background-color':com.readerScore1=='NaN' && com.readerScore1 === com.readerScore1 ? 'red' : '#ffd966'}">{{com.colorCode}}</td>
																	</tr>
																</tbody>
															</table>
														</accordion-group>
														<accordion-group [isOpen]="group.multiple_pending" class="mb-3" *ngIf="applicationCounts.multiple_pending > 0">
															<button class="btn btn-link btn-block clearfix" accordion-heading type="button">
																<div class="pull-left float-left">MULTIPLE STEPS PENDING</div>
																<span class="badge  float-right pull-right">{{applicationCounts.multiple_pending}}</span>
															</button>
															<table class="table table-striped">
																<thead>
																	<tr>
																		<th scope="col">AppID</th>
																		<th scope="col">First Name</th>
																		<th scope="col">Last Name</th>
																		<th scope="col">Submitted Recommendations</th>
																		<th scope="col">Completed Steps</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let com of reportsData.multiple_pending">
																		<td>{{com.applicationCode}}</td>
																		<td>{{com.firstName}}</td>
																		<td>{{com.lastName}}</td>
																		<td>{{com.submittedApplicantRecommendations}}</td>
																		<td>{{com.completedSteps}}</td>
																	</tr>
																</tbody>
															</table>
														</accordion-group>
													</accordion>
												</div>
												<div class="col-md-4 mt-3">
													<div class="charjs">
														<div class="chart-wrapper" *ngIf="doughnutChartLabels.length > 0">
															<canvas baseChart
																	[data]="doughnutChartData"
																	[labels]="doughnutChartLabels"
																	[chartType]="doughnutChartType"
																	[options]="doughnutChartOptions"
																	[plugins]="doughnutChartPlugins"
																	[colors]="doughnutChartColors"
																	(chartClick)="doughnutChartClicked($event)"
																	height="275"></canvas>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row reports" *ngIf="!accordionView">
										<div class="col-md-5 pr-1">
											<div class="box">
												<div class="reportHeader">TOTAL APPLICATIONS</div>
												<div class="row mt-1">
													<div class="col-md-6 text-left" style="padding-right: 0;">
														<div class="bg-color">
															<span class="counttxt">Total Count of Students</span>
															<h1 class="count" style="font-size: 56px;">{{applicationCounts.total_applications}}</h1>
														</div>
													</div>
													<div class="col-md-6 my-auto text-center pl-2"><button class="btn btn-primary btn-sm" (click)="exportSectionData(collegeName, 'COMPLETE')">Export the Report</button></div>
													<div class="col-md-6 text-right pr-1">
														<div class="reportHeader">COMPLETE APPLICATIONS</div>
														<div class="text-left">
															<div class="bg-color">
																<span class="counttxt">Count of Students</span>
																<h1 class="count" style="font-size: 56px;">{{applicationCounts.complete}}</h1>
															</div>
														</div>
														<table>
															<tr>
															<th>AppID</th>
															<th>First Name</th>
															<th>Last Name</th>
															<th>Race/EtHnicity</th>
															</tr>
															<tr *ngFor="let com of reportsData.complete">
																<td>{{com.applicationCode}}</td>
																<td>{{com.firstName}}</td>
																<td>{{com.lastName}}</td>
																<td>{{com.ethnicity}}</td>
															</tr>
														</table>
													</div>
													<div class="col-md-6 text-right pl-1 ">
														<div class="reportHeader">INCOMPLETE APPLICATIONS</div>
														<div class="text-left">
															<div class="bg-color">
																<span class="counttxt">Count of Students</span>
																<h1 class="count" style="font-size: 56px;">{{applicationCounts.incomplete}}</h1>
															</div>
														</div>
														<table>
															<tr>
															<th>AppID</th>
															<th>First Name</th>
															<th>Last Name</th>
															<th>Steps</th>
															<th>% Completion</th>
															</tr>
															<tr *ngFor="let com of reportsData.incomplete">
																<td>{{com.applicationCode}}</td>
																<td>{{com.firstName}}</td>
																<td>{{com.lastName}}</td>
																<td>{{com.completedSteps}}</td>
																<td>{{com.percentCompletion}}%</td>
															</tr>
														</table>
													</div>
												</div>
											</div>
										</div>
										<div class="col pl-0 pr-0">
											<div class="box ">
												<div class="reportHeader">ONLY SUBMISSION PENDING</div>
												<div class="row mt-1">
													<div class="col-md-5 text-left pr-0">
														<div class="bg-color">
															<span class="counttxt">Count of Students</span>
															<h1 class="count">{{applicationCounts.submission_pending}}</h1>
														</div>
													</div>
													<div class="col-md-7 my-auto text-center pl-2">
														<button class="btn btn-primary btn-sm mb-1" (click)="exportSectionData(collegeName, 'SUBMISSION_PEND');">Export the Report</button>
													</div>
													<div class="col-md-12 text-right ">
														<table>
															<tr>
															<th>AppID</th>
															<th>First Name</th>
															<th>Last Name</th>
															<th>Completed Steps</th>
															</tr>
															<tr *ngFor="let com of reportsData.submission_pending">
																<td>{{com.applicationCode}}</td>
																<td>{{com.firstName}}</td>
																<td>{{com.lastName}}</td>
																<td>{{com.completedSteps}}</td>
															</tr>
														</table>
													</div>
												</div>
											</div>
											<div class="box bx-2 mt-1">
												<div class="reportHeader">ONLY TRANSCRIPTS REQUIRED</div>
												<div class="row mt-1">
													<div class="col-md-5 text-left pr-0">
														<div class="bg-color">
															<span class="counttxt">Count of Students</span>
															<h1 class="count">{{applicationCounts.transcripts_pending}}</h1>
														</div>
													</div>
													<div class="col-md-7 my-auto text-center pl-2">
														<button class="btn btn-primary btn-sm mb-1" (click)="exportSectionData(collegeName, 'TRANSCRIPT_PEND');">Export the Report</button>
													</div>
													<div class="col-md-12 text-right ">
														<table>
															<tr>
															<th>AppID</th>
															<th>First Name</th>
															<th>Last Name</th>
															<th>Completed Steps</th>
															</tr>
															<tr *ngFor="let com of reportsData.transcripts_pending">
																<td>{{com.applicationCode}}</td>
																<td>{{com.firstName}}</td>
																<td>{{com.lastName}}</td>
																<td>{{com.completedSteps}}</td>
															</tr>
														</table>
													</div>
												</div>
											</div>
										</div>
										<div class="col pl-1">
											<div class="box box-3">
												<div class="reportHeader">ONLY RECOMMENDATIONS PENDING</div>
												<div class="row mt-1">
													<div class="col-md-5 text-left  pr-0">
														<div class="bg-color">
															<span class="counttxt">Count of Students</span>
															<h1 class="count">{{applicationCounts.recommendation_pending}}</h1>
														</div>
													</div>
													<div class="col-md-7 my-auto text-center pl-2">
														<button class="btn btn-primary btn-sm" (click)="exportSectionData(collegeName, 'RECOMMEND_PEND');">Export the Report</button>
													</div>
													<div class="col-md-12 text-right ">
														<table class="tb-list">
															<tr>
															<th>AppID</th>
															<th>First Name</th>
															<th>Last Name</th>
															<th><span>Recommend 1</span></th>
															<th><span>Recommend 2</span></th>
															<th>Color Code</th>
															</tr>
															<tr *ngFor="let com of reportsData.recommendation_pending">
																<td>{{com.applicationCode}}</td>
																<td>{{com.firstName}}</td>
																<td>{{com.lastName}}</td>
																<td>{{com.readerScore1}}</td>
																<td>{{com.readerScore2}}</td>
																<td [ngStyle]="{'background-color':com.readerScore1=='NaN' && com.readerScore1 === com.readerScore1 ? 'red' : '#ffd966'}">{{com.colorCode}}</td>
															</tr>
														</table>
													</div>
												</div>
											</div>
											<div class="box mt-1 ">
												<div class="reportHeader">MULTIPLE STEPS PENDING </div>
												<div class="row mt-1">
													<div class="col-md-5 text-left  pr-0">
														<div class="bg-color">
															<span class="counttxt">Count of Students</span>
															<h1 class="count">{{applicationCounts.multiple_pending}}</h1>
														</div>
													</div>
													<div class="col-md-7 my-auto text-center pl-2">
														<button class="btn btn-primary btn-sm" (click)="exportSectionData(collegeName, 'MULTIPLE_PEND');">Export the Report</button>
													</div>
													<div class="col-md-12 text-right ">
														<table class="tb-list">
															<tr>
															<th>AppID</th>
															<th>First Name</th>
															<th>Last Name</th>
															<th>Submitted Recs</th>
															<th>Completed Steps</th>
															</tr>
															<tr *ngFor="let com of reportsData.multiple_pending">
																<td>{{com.applicationCode}}</td>
																<td>{{com.firstName}}</td>
																<td>{{com.lastName}}</td>
																<td>{{com.submittedApplicantRecommendations}}</td>
																<td>{{com.completedSteps}}</td>
															</tr>
														</table>
													</div>
												</div>
											</div>
										</div>
										<div class="col-md-12 text-center  pt-4">
											<button type="button" class="btn btn-info"  (click)="openModalWithClass(sharePopup);">Share the report</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade row " id="nav-detailed" role="tabpanel" aria-labelledby="nav-detailed-tab">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-4">
									<app-select idKey="key" labelKey="value" [options]="colleges" 
										 [model]="collegeName" placeHolder="All High Schools" sortRequired="true"
							 			 (selectChange)="collegeName=$event;getCollegeReport($event);getDetailsPageChartData($event);"></app-select>
									
								</div> 
								<div class="col-md-8 text-right">
									<span class="total" *ngIf="showDetailsCharts">Applications Completed Count  = {{detailsApplicationCounts.complete}}</span>
								</div> 
							</div>
							<div class="row">
								<div class="col-md-12" style="font-size: x-large;" *ngIf="!showDetailsCharts">Loading...</div>
								<div class="col-filterd col-md-12" id="all-college" *ngIf="showDetailsCharts">
									<div class="row">
										<div class="col-md-6">
											<div class="chart-img">
												<div class="chartTitle">Racial distribution of students</div>
												<div class="chart-wrapper">
													<canvas baseChart 
														[datasets]="detailsBarChartData"
														[labels]="detailsBarChartLabels"
														[options]="barChartOptions"
														[legend]="barChartLegend"
														[chartType]="barChartType">
												</canvas>
												</div>
											</div>
										</div>
										<div class="col-md-6">
											<div class="chart-img">
												<div class="chartTitle">Gender of the students</div>
												<div class="chart-wrapper">
													<canvas baseChart 
													[data]="detailsPieChartData" 
													[labels]="detailsPieChartLabels" 
													[chartType]="pieChartType"
													[options]="pieChartOptions"
													[colors]="pieChartColors"
													[legend]="pieChartLegend">
												</canvas>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12" *ngIf="collegeName.length > 0">
											<div class="chart-img">
												<div class="chartTitle">Application - YOY Trend Comparison</div>
												<div class="chart-wrapper">
													<canvas baseChart 
														[datasets]="detailsLineChartData" 
														[labels]="detailsLineChartLabels" 
														[options]="lineChartOptions"
														[legend]="lineChartLegend" 
														[chartType]="lineChartType" 
														[plugins]="lineChartPlugins" height="80">
													</canvas>
												</div>
											</div>
										</div>
										<div class="col-md-6" *ngIf="collegeName.length === 0">
											<div class="chart-img">
												<div class="chartTitle">Application - YOY Trend Comparison</div>
												<div class="chart-wrapper">
													<canvas baseChart 
														[datasets]="detailsLineChartData" 
														[labels]="detailsLineChartLabels" 
														[options]="lineChartOptions"
														[legend]="lineChartLegend" 
														[chartType]="lineChartType" 
														[plugins]="lineChartPlugins">
													</canvas>
												</div>
											</div>
										</div>
										<div class="col-md-6" *ngIf="collegeName.length === 0">
											<div class="chart-img">
												<div class="chartTitle">Application count - By High School</div>
												<div class="chart-wrapper">
													<canvas baseChart 
														[datasets]="detailsBarSchoolChartData"
														[labels]="detailsBarSchoolChartLabels"
														[options]="virticalBarCharOptions"
														[legend]="barChartLegend"
														[chartType]="barChartType">
													</canvas>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade row " id="nav-segmentation" role="tabpanel" aria-labelledby="nav-segmentation-tab">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-4">
									<app-select idKey="key" labelKey="value" [options]="regions" [model]="region" sortRequired="true" (selectChange)="getRegions($event);"></app-select>
								</div> 
								<div class="col-md-8 text-right">
									<span class="total" *ngIf="showSegmentationCharts">Applications Completed Count  = {{totalSegmentationCount}}</span>
								</div> 
							</div>
							<div class="row">
								<div class="col-md-12" style="font-size: x-large;" *ngIf="!showSegmentationCharts">Loading...</div>
								<div class="col-filterd col-md-12" id="all-college" *ngIf="showSegmentationCharts">
									<div class="row">
										<div class="col-md-6">
											<div class="chart-img">
												<div class="chartTitle">Racial distribution of students</div>
												<div class="chart-wrapper">
													<canvas baseChart 
														[datasets]="segmentationBarChartData"
														[labels]="segmentationBarChartLabels"
														[options]="barChartOptions"
														[legend]="barChartLegend"
														[chartType]="barChartType">
												</canvas>
												</div>
											</div>
										</div>
										<div class="col-md-6">
											<div class="chart-img">
												<div class="chartTitle">Gender of the students</div>
												<div class="chart-wrapper">
													<canvas baseChart 
													[data]="segmentationPieChartData" 
													[labels]="segmentationPieChartLabels" 
													[chartType]="pieChartType"
													[options]="pieChartOptions"
													[colors]="pieChartColors"
													[legend]="pieChartLegend">
												</canvas>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<div class="chart-img">
												<div class="chartTitle">Application count - By High School</div>
												<div class="chart-wrapper">
													<canvas baseChart 
														[datasets]="segmentationBarSchoolChartData"
														[labels]="segmentationBarSchoolChartLabels"
														[options]="virticalBarCharOptions"
														[legend]="barChartLegend"
														[chartType]="barChartType">
													</canvas>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="tab-pane fade row " id="nav-program" role="tabpanel" aria-labelledby="nav-program-tab">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-4">
									<app-select idKey="key" labelKey="value" [options]="programs" [model]="program" sortRequired="true" (selectChange)="getPrograms($event);"></app-select>									
								</div> 
								<div class="col-md-8 text-right">
									<span class="total" *ngIf="showProgramCharts">
										Applications Completed Count  = {{totalProgramCount}}
									</span>
								</div> 
							</div>
							<div class="row">
								<div class="col-md-12" style="font-size: x-large;" *ngIf="!showProgramCharts">Loading...</div>
								<div class="col-filterd col-md-12" id="all-college" *ngIf="showProgramCharts">
									<div class="row">
										<div class="col-md-6">
											<div class="chart-img">
												<div class="chartTitle">Racial distribution of students</div>
												<div class="chart-wrapper">
													<canvas baseChart 
														[datasets]="programBarChartData"
														[labels]="programBarChartLabels"
														[options]="barChartOptions"
														[legend]="barChartLegend"
														[chartType]="barChartType">
												</canvas>
												</div>
											</div>
										</div>
										<div class="col-md-6">
											<div class="chart-img">
												<div class="chartTitle">Gender of the students</div>
												<div class="chart-wrapper">
													<canvas baseChart 
													[data]="programPieChartData" 
													[labels]="programPieChartLabels" 
													[chartType]="pieChartType"
													[options]="pieChartOptions"
													[colors]="pieChartColors"
													[legend]="pieChartLegend">
												</canvas>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<div class="chart-img">
												<div class="chartTitle">Application count - By High School</div>
												<div class="chart-wrapper">
													<canvas baseChart 
														[datasets]="programBarSchoolChartData"
														[labels]="programBarSchoolChartLabels"
														[options]="virticalBarCharOptions"
														[legend]="barChartLegend"
														[chartType]="barChartType">
													</canvas>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
    <p style="color: white">Please Wait. </p>  
</ngx-spinner> 

<!-- <ng-template #deepdiva>
	<div class="modal-header virtue-header">
		<h2>Please select the High Schools for comparison</h2>
		<button type="button" class="close" reportsData-dismiss="modal" aria-label="Close" (click)="close()">
			<span aria-hidden="true">&times;</span>
		  </button>
	</div>
	<div class="modal-body virtue-body">
		<form id="" class="form-horizontal" role="form">
				<div class="form-group row">	 
				  <div class="col-sm-4">
					<select id="mySelect" class="mb-2 options-s">
						<option value="college2">Harding High School</option>
						<option value="college2">Cristo Rey High School</option>
						<option value="college1">Patrick Henry High School</option>
						<option>Champlin Park High School</option>
						<option>Blain High School</option>
						<option>Central High School</option>
					    <option >Brooklyn Center High School</option>
					 </select>
				  </div>
				  <div class="col-sm-4">
					<select id="mySelect" class="mb-2 options-s">
						<option value="college2">Cristo Rey High School</option>
						<option value="college2">Harding High School</option>
						<option value="college1">Patrick Henry High School</option>
						<option>Champlin Park High School</option>
						<option>Blain High School</option>
						<option>Central High School</option>
					    <option >Brooklyn Center High School</option>
					 </select>
				  </div>
				  <div class="col-sm-4">
					<select id="mySelect" class="mb-2 options-s">
						<option value="college1">Patrick Henry High School</option>
						<option value="college2">Cristo Rey High School</option>
						<option value="college2">Harding High School</option>
						<option>Champlin Park High School</option>
						<option>Blain High School</option>
						<option>Central High School</option>
					    <option >Brooklyn Center High School</option>
					 </select>
				  </div>
				</div>
				<div class="row">
                   <div class="col-md-12">
					<div class="chart-img">
						<img src="./assets/images/mom.png">
					</div>
				   </div>
				</div>
				</form>
				</div>
</ng-template> -->
<ng-template #sharePopup>
	<div class="modal-header virtue-header">
		<div class="virtue-logo">
			<img src="https://tech.virtueanalytics.com/wepcsr/assets/images/logo-backup.png" alt="virtue logo"/>
		</div>
		<button type="button" class="close" reportsData-dismiss="modal" aria-label="Close" (click)="close()">
			<span aria-hidden="true">&times;</span>
		  </button>
	</div>
	<div class="modal-body virtue-body">
		<form id="" class="form-horizontal" role="form" [formGroup]="sentReportForm">
				<div class="form-group row">
				  <label for="inputEmail3" class="col-sm-4 col-form-label">Counselor Email</label>
				  <div class="col-sm-8">
                    <input type="email" class="form-control"  formControlName="inputEmail3" placeholder="Email">				  </div>
				</div>
				<div class="form-group row">
				  <label for="subject" class="col-sm-4 col-form-label">Subject</label>
				  <div class="col-sm-8">
					<input type="email" class="form-control" id="subject" placeholder="Subject" formControlName="subject">
				  </div>
				</div>
				<div class="form-group row">
				  <label for="exampleFormControlTextarea1" class="col-sm-4 col-form-label">Additional Comments</label>
				  <div class="col-sm-8">
					<textarea class="form-control" id="exampleFormControlTextarea1" rows="3"  placeholder="Comments" formControlName="exampleFormControlTextarea1"></textarea>
				  </div>
				</div>
				<div class="form-group row ">
					<div class="col-sm-12 text-center">
					  <button type="button" class="btn btn-info pl-5 pr-5" (click)="sentReport()" >Send</button>
				   </div>
				</div>
			
				</form>
				</div>
</ng-template>
<ng-template #exportPopup>
	<div class="modal-header virtue-header">
		<div class="virtue-logo">
			<img src="https://tech.virtueanalytics.com/wepcsr/assets/images/logo-backup.png" alt="virtue logo"/>
		</div>
	</div>
	<div class="modal-body virtue-body">
		<form id="virtueVisitorForm" class="form-horizontal" role="form">
			<div class="form-group">
				<div class="col-lg-12">
					<h3 class="virtue-title">Coming Soon...</h3>
				</div>
			</div>
			<div class="form-group margin-t-25 margin-lr-25">
				<div class="col-lg-12 text-center">
					<button type="button" class="btn page-btn" (click)="close()">Close</button> 
				</div>
			</div>
		</form>
	</div>
</ng-template>